module.exports = __webpack_public_path__ + "img/ic_arrow_after.03e72696.svg";